var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-input',{attrs:{"value":_vm.query,"placeholder":_vm.placeholder,"size":_vm.size,"autocomplete":"off"},on:{"input":_vm.debounceQuery}})
}
var staticRenderFns = []

export { render, staticRenderFns }